export const updatedObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues
    }
};